import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: number = 0;

export const leftNavigationTabSlice = createSlice({
 name: 'leftNavigationCurrenTab',
 initialState,
 reducers: {
  setLeftNavigationCurrentTab: (state, action: PayloadAction<number>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { setLeftNavigationCurrentTab } = leftNavigationTabSlice.actions;

export default leftNavigationTabSlice.reducer;
